/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper, useFlags } from 'sarsaparilla';
import axios from 'axios';
import { getPRSCheckoutURL } from 'ui-cart/src/utils/cart_utils';
import * as constants from 'ui-cart/src/constants';
import { useWafChallenge, postPrsPayment } from '../../utils/wafChallenge';

export default function BuyNowApplePay({ cartData, onComplete }) {
    const { enableApplePayWeb, enablePrsWafChallenge } = useFlags();

    useWafChallenge(enablePrsWafChallenge);

    const isAvailable = enableApplePayWeb && window.ApplePaySession;

    if (!isAvailable) {
        return null;
    }

    const handleApplePayClick = async () => {
        if (!window.ApplePaySession) {
            return;
        }

        const headers = { Authorization: SecurityHelper.getAuthHeader() };

        let checkoutID;
        let checkoutToken;

        try {
            const checkoutResponse = await axios.post(
                `${process.env.API}/cart/checkout`,
                {},
                { headers }
            );
            checkoutID = checkoutResponse.data.checkout_id;
            checkoutToken = checkoutResponse.data.token;
        } catch {
            return;
        }

        const request = {
            countryCode: 'US',
            currencyCode: 'USD',
            merchantCapabilities: ['supports3DS'],
            supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
            total: {
                label: process.env.SITE_NAME,
                type: 'final',
                amount: cartData?.total || '0',
            },
        };

        const session = new window.ApplePaySession(3, request);

        session.onvalidatemerchant = async () => {
            try {
                const response = await axios.get(
                    `${process.env.API}/cart/apple-pay/merchant-validation`,
                    { headers }
                );
                session.completeMerchantValidation(response.data);
            } catch {
                session.abort();
            }
        };

        session.onpaymentauthorized = async (event) => {
            const paymentURL = getPRSCheckoutURL();

            const paymentRequest = {
                checkout_id: checkoutID,
                checkout_token: checkoutToken,
                payment_data: {
                    payment_type: constants.PAYMENT_TYPE_MOBILE,
                    mobile_data: {
                        vendor: 'apple',
                        token: btoa(JSON.stringify(event.payment.token.paymentData)),
                    },
                },
            };

            let resultStatus = window.ApplePaySession.STATUS_SUCCESS;
            try {
                await postPrsPayment(`${paymentURL}/${checkoutID}`, paymentRequest, {
                    enableWaf: enablePrsWafChallenge,
                });
                if (onComplete) {
                    onComplete();
                }
                window.location.assign(`/cart?finalize=${checkoutID}`);
            } catch {
                resultStatus = window.ApplePaySession.STATUS_FAILURE;
            }

            session.completePayment({ status: resultStatus });
        };

        session.begin();
    };

    return (
        <div className="buy-now-apple-pay">
            <apple-pay-button
                buttonstyle="black"
                type="buy"
                locale="en-US"
                onClick={handleApplePayClick}
            />
        </div>
    );
}
